import { useEffect, useState } from 'react';
import NoArticleImg from '../../assets/no-article.svg';
import WriteIcon from '../../assets/write-icon.svg';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAtom } from 'jotai';
import { profileAtom } from '../Settings/atom';

const EmptyArticleComponent = ({ currentTopicId, categoryType }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [mainDescription, setMainDescription] = useState('');
  const [subDescription, setSubDescription] = useState('');
  const [buttonNavigate, setButtonNavigate] = useState('/');
  const [buttonText, setButtonText] = useState('');
  const [profile] = useAtom(profileAtom);

  useEffect(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    let type = categoryType || pathSegments[pathSegments.length - 1];

    switch (type) {
      case 'forYou': {
        setMainDescription('No articles for you at the moment!');
        setSubDescription(
          'Check out the News Hub for trending stories or be the first to contribute!'
        );
        setButtonNavigate('/?tab=newsHub');
        setButtonText('Explore News Hub');
        break;
      }
      case 'recent': {
        setMainDescription('No articles at the moment!');
        setSubDescription(
          'Check the News Hub for inspiration or write something impactful to start the trend'
        );
        setButtonNavigate('/?tab=newsHub');
        setButtonText('Get Writing Ideas');
        break;
      }
      case 'breaking-news':
      case 'breaking': {
        setMainDescription('No breaking news at the moment.');
        setSubDescription('Stay tuned for updates or start a trend with your own insights!');
        setButtonNavigate('/article/create');
        setButtonText('Write');
        break;
      }
      case 'following': {
        setMainDescription('It looks like you haven’t followed any writers yet.');
        setSubDescription('Follow some featured voices to start seeing their content here!');
        setButtonNavigate('/featured-voices');
        setButtonText('Discover Featured Voices');
        break;
      }
      case 'myReading': {
        setMainDescription(
          'It looks like you haven’t added any articles to your <b>Reading List</b> yet.'
        );
        setSubDescription('Start exploring and add some favorites to stay updated!');
        setButtonNavigate('/?tab=forYou');
        setButtonText('Find Articles to Read');
        break;
      }
      case 'myArticles': {
        if (currentTopicId) {
          setMainDescription(
            'It looks like you haven’t published any articles under this topic yet!'
          );
          setSubDescription(
            'Expand your content to add more diversity, reach more readers, and boost your visibility!'
          );
        } else {
          setMainDescription('It looks like you haven’t published any articles yet.');
          setSubDescription('Share your story and become part of our growing community!');
        }
        setButtonText('Write');
        setButtonNavigate('/article/create');
        break;
      }
      case 'myComments': {
        setMainDescription('It looks like you haven’t commented on any articles yet.');
        setSubDescription('Share your story and become part of our growing community!');
        setButtonNavigate('/');
        setButtonText('Find Articles to Read');
        break;
      }
      case 'myLikes': {
        setMainDescription('It looks like you haven’t reacted to any articles yet.');
        setSubDescription(
          'Find articles that spark your interest and leave a reaction to express your thoughts!'
        );
        setButtonNavigate('/');
        setButtonText('Find Articles to Read');
        break;
      }
      case 'categories': {
        setMainDescription('No articles found in this category yet!');
        setSubDescription('Discover articles in other topics or be the first to contribute!');
        setButtonNavigate('/article/create');
        setButtonText('Write');
        break;
      }
      case 'related-articles': {
        setMainDescription('No articles under this story at the moment.');
        setSubDescription('Stay tuned for updates or start a trend with your own insights!');
        setButtonText();
        break;
      }
      case 'newsHub': {
        setMainDescription('Unable to load trending stories at the moment.');
        setSubDescription(
          'Check your connection or try again later. In the meantime, explore our community content!'
        );
        setButtonNavigate('/?tab=trending');
        setButtonText('View Community Articles');
        break;
      }
      default: {
        setMainDescription('No articles under this topic at the moment.');
        setSubDescription('Stay tuned for updates or start a trend with your own insights!');
        setButtonNavigate('/article/create');
        setButtonText('Write');
        break;
      }
    }
  }, [categoryType]);

  function handleChangeTab() {
    navigate(buttonNavigate);
  }

  return (
    <div className="flex flex-col gap-4 items-center">
      <img src={NoArticleImg} className="w-[48px] h-[48px]" alt="" />
      <p
        dangerouslySetInnerHTML={{ __html: mainDescription }}
        className="font-[600] text-base md:text-lg text-center"
      ></p>
      <p className="font-[400] text-base md:text-lg text-center">{subDescription}</p>
      <div className="flex flex-col items-center">
        {buttonText ? (
          buttonText === 'Write' ? (
            profile?.isCreator ? (
              <Button
                variant="primary"
                className="w-fit text-sm md:text-base whitespace-nowrap"
                onClick={handleChangeTab}
              >
                <p>{buttonText}</p>
                <img src={WriteIcon} alt="" className="ml-2 w-5 h-5" />
              </Button>
            ) : null
          ) : (
            <Button
              variant="secondary"
              className="w-fit text-sm md:text-base whitespace-nowrap"
              onClick={handleChangeTab}
            >
              <p>{buttonText}</p>
            </Button>
          )
        ) : null}
      </div>
    </div>
  );
};

export default EmptyArticleComponent;
